import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/RulesCategories/selectRow',
                {
                    params,
                });
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/RulesCategories/updateRow', params);
            }
            else
            {
                response = await axios.post('/RulesCategories/insertRow', params);
            }
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/RulesCategories/deleteRow', params);
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
};
